import React,{useState} from 'react';
import { Button, Modal } from 'react-bootstrap';

 export function MyVerticallyCenteredModal(props) {
    return (
      <Modal
        {...props}
        aria-labelledby="contained-modal-title-vcenter"
        centered="true"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Modal heading
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>Centered Modal</h4>
          <p>
            Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
            dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
            consectetur ac, vestibulum at eros.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
  
  export default function DrafteJObModel({editJob,editBtn, closeModel, showModel, jobStartDate}){
       
    const handleClose = () => { closeModel() };

    const pageRedirect = () => {
      editJob()
    }
    
    return(
      // <Modal show={showModel} onHide={handleClose} centered>
      //     <Modal.Header closeButton>
      //       <Modal.Title>Job Start Date</Modal.Title>
      //     </Modal.Header>
      //   <Modal.Body><em>Project Start Date MUST be no less than 15 days from the Project Creation/Submission Date</em></Modal.Body>
      //   <Modal.Footer>
      //     <Button variant="secondary" onClick={()=>handleClose()}>
      //       Close
      //     </Button>
      //     <Button variant="primary" onClick={()=>pageRedirect()}>
      //       {editBtn}
      //     </Button>
      //   </Modal.Footer>
      // </Modal>

      // new popup modal
      <Modal show={showModel} onHide={handleClose} centered>
          <Modal.Header className="no-border text-center">
            <Modal.Title className="modal-title w-100 font-weight-bolder">Job Start Date</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center"> Project Start Date Must be No less than 15 days from the Project Creation/Submission Date.</Modal.Body>
          <Modal.Footer className="no-border">
            <Button className="w-100  font-weight-bold btn-logout" variant="primary" onClick={()=>handleClose()}>
            CLOSE
            </Button>
            <Button className="w-100 font-weight-bold btn-logout" variant="danger" onClick={()=>pageRedirect()}>
            {editBtn}
            </Button>
          </Modal.Footer>
        </Modal>
    )
  }
